define('plugin/client-login/view/ClientLoginFormModuleView',['require','lib/view/FormView','Config','collection/CountryCollection','collection/StateCollection'],function (require) {

    var FormView = require('lib/view/FormView');
    var Config = require('Config');

    var CountryCollection = require('collection/CountryCollection');
    var StateCollection = require('collection/StateCollection');

    /**
     * Client login form module view
     *
     * @class ClientLoginFormModuleView
     */
    return FormView.extend({

        template: '#client_login_module_form',
        ui: {
            'sign_out_btn': '#sb_sign_out_btn',
            'sign_in_btn': '#sb_sign_in_btn',
            'inputs': ':input'
        },
        triggers: {
            'click @ui.sign_out_btn': {
                event: 'signOut',
                stopPropagation: false
            },
            'click @ui.sign_in_btn': 'signIn'
        },
        modelEvents: {
            'invalid': 'safeRender',
            'sync': 'safeRender'
        },
        events: {
            'keyup @ui.inputs': '_onInputKeyUp'
        },

        initialize: function () {
            this.countryCollection = CountryCollection.getInstance();
            this.stateCollection = new StateCollection.getInstance();

            this.listenTo(this.countryCollection, 'sync', this.safeRender);
            this.listenTo(this.stateCollection, 'sync', this.safeRender);

            this.listenTo(this.getOption('clientModel'), 'sync', this.safeRender);
        },

        getDataToSignIn: function () {
            return this._getData(this.ui.inputs);
        },

        serializeData: function () {
            var result = this._serializeData();
            result.client_data = this.getOption('clientModel').toJSON();
            result.allow_registration = (parseInt(Config.getInstance().getOption('client_login_allow_registration')) === 1);

            result.countries = this.getCountryList();
            result.states = this.getStateList();

            return result;
        },
        
        _onInputKeyUp: function (event) {
            if (event.keyCode === this.KEY_ENTER && !event.shiftKey) {
                this.ui.sign_in_btn.trigger('click');
            }
        },

        getCountryList: function () {
            this.countryCollection.load();
            return this.countryCollection.toJSON();
        },

        getStateList: function () {
            this.stateCollection.load();
            return this.stateCollection.toJSON();
        }

    });

});
